import { Div } from "components";
import React from "react";
import { apiAsset } from "services/apiAsset";
import { useQuery } from "./asset_hook";
import Item_list_by_scheme from "./item_list_by_scheme";

const List_By_Scheme = () => {
  const { data } = useQuery(() => apiAsset.getAssetByProgram());
  return (
    <Div flex={1} alignItems="center" paddingTop={16}>
      {data?.map((item: any, index: number) => {
        return <Item_list_by_scheme data={item} key={index} />;
      })}
    </Div>
  );
};

export default React.memo(List_By_Scheme);
